<template>
  <c-box
    :aria-label="ariaLabel"
    px="0"
    pt="0"
    :mb="{ base: 'xs', sm: 'sm' }"
    :lineHeight="{ base: 1.2, sm: 1.6 }"
    w="100%"
    overflow="hidden"
  >
    <c-box float="left" width="auto" maxWidth="50%" minWidth="30%">
      <c-text as="span" v-if="label" fontSize="md" verticalAlign="top">{{ label }}</c-text>
    </c-box>
    <c-box overflow="hidden" textAlign="right">
      <c-text as="span" fontSize="md" float="right" textAlign="right"><slot /></c-text>
    </c-box>
  </c-box>
</template>

<script>
import { CText, CBox } from "@chakra-ui/vue";

/**
 * Fields are used to visually separate field label and contents.
 */
export default {
  name: "Field",
  status: "prototype",
  release: "0.0.1",
  components: {
    CBox,
    CText,
  },
  props: {
    /**
     * Descriptive text to be read to screenreaders.
     */
    ariaLabel: {
      type: String,
      default: "",
    },
    /**
     * Text label
     */
    label: {
      type: String,
      default: "",
    },
  },
};
</script>
